import { type ReactNode } from 'react'
import styles from './EmptyState.module.css'

type EmptyStateProps = {
  children?: ReactNode
  className?: string
  message?: ReactNode
}

export const EmptyState = ({ children, className, message }: EmptyStateProps) => (
  <div className={[styles.empty, className].filter(Boolean).join(' ')}>
    {children ?? message}
  </div>
)
